import React from 'react';
import { useStyles } from './TopMenu.styles';

export const TopMenu: React.FC = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.container}>{children}</div>;
};
